
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1xupv_fwwis_94",
  "wizard": "awsui_wizard_1xupv_fwwis_107",
  "refresh": "awsui_refresh_1xupv_fwwis_107",
  "small-container": "awsui_small-container_1xupv_fwwis_114",
  "navigation": "awsui_navigation_1xupv_fwwis_123",
  "number": "awsui_number_1xupv_fwwis_185",
  "circle": "awsui_circle_1xupv_fwwis_201",
  "title": "awsui_title_1xupv_fwwis_209",
  "active": "awsui_active_1xupv_fwwis_238",
  "disabled": "awsui_disabled_1xupv_fwwis_249",
  "enabled": "awsui_enabled_1xupv_fwwis_259",
  "form": "awsui_form_1xupv_fwwis_298",
  "form-header": "awsui_form-header_1xupv_fwwis_304",
  "background": "awsui_background_1xupv_fwwis_315",
  "form-header-content": "awsui_form-header-content_1xupv_fwwis_325",
  "form-component": "awsui_form-component_1xupv_fwwis_329",
  "hidden": "awsui_hidden_1xupv_fwwis_343",
  "collapsed-steps": "awsui_collapsed-steps_1xupv_fwwis_347",
  "collapsed-steps-extra-padding": "awsui_collapsed-steps-extra-padding_1xupv_fwwis_352",
  "collapsed-steps-hidden": "awsui_collapsed-steps-hidden_1xupv_fwwis_355",
  "form-header-component-wrapper": "awsui_form-header-component-wrapper_1xupv_fwwis_359",
  "form-header-component": "awsui_form-header-component_1xupv_fwwis_359",
  "navigation-link": "awsui_navigation-link_1xupv_fwwis_372",
  "navigation-link-item": "awsui_navigation-link-item_1xupv_fwwis_373",
  "navigation-link-label": "awsui_navigation-link-label_1xupv_fwwis_374",
  "navigation-link-active": "awsui_navigation-link-active_1xupv_fwwis_378",
  "navigation-link-disabled": "awsui_navigation-link-disabled_1xupv_fwwis_383",
  "cancel-button": "awsui_cancel-button_1xupv_fwwis_387",
  "previous-button": "awsui_previous-button_1xupv_fwwis_388",
  "primary-button": "awsui_primary-button_1xupv_fwwis_389",
  "skip-to-button": "awsui_skip-to-button_1xupv_fwwis_390",
  "action-buttons": "awsui_action-buttons_1xupv_fwwis_394"
};
  